<template>
  <div>
    <back-btn />
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="institutionData === undefined"
    >
      <h4 class="alert-heading">
        Erro ao buscar institution data
      </h4>
      <div class="alert-body">
        No institution found with this institution id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'institutions-list'}"
        >
          Institution List
        </b-link>
        for other institutions.
      </div>
    </b-alert>

    <template v-if="institutionData">
      <b-row class="match-height">
        <b-col
          cols="12"
          md="12"
          lg="12"
          xl="12"
        >
          <institution-view-institution-info-card
            :institution-data="institutionData"
            :workplace="workplaceData"
          />
        </b-col>
      </b-row>
      <div>
        <!-- Table Container Card -->
        <b-card
          no-body
          class="mb-0"
        >
          <div class="m-2">
            <physician-list-filters
              :per-page.sync="perPage"
              :per-page-options="perPageOptions"
              :status-filter.sync="statusFilter"
              :status-options="statusOptions"
              :search-query.sync="searchQuery"
              :is-add-new-physician-sidebar-active.sync="isAddNewPhysicianSidebarActive"
            />
          </div>

          <b-table
            ref="refPhysicianListTable"
            class="position-relative"
            :items="fetchPhysicians"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro correspondente encontrado"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="`light-${resolveStatusVariant(data.item.status)}`"
                class="text-capitalize"
              >
                {{ getPhysicianStatus(data.item.status) }}
              </b-badge>
            </template>
            <template #cell(motive)="data">
              <div :title="data.item.motive">
                {{ truncateString(data.item.motive, 20) }}
              </div>
            </template>
            <template #cell(physician.name)="data">
              <strong>{{ data.item.physician.name }}</strong>
              <div>{{ formatCpf(data.item.physician.cpf) }}</div>
            </template>
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click="openAddContract(data.item)"
                >
                  <feather-icon icon="UploadIcon" />
                  <span class="align-middle ml-50">Anexar contrato</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="['pending', 'denied'].includes(data.item.status)"
                  @click="approveCnpj(data.item, 'approved')"
                >
                  <feather-icon icon="CheckCircleIcon" />
                  <span class="align-middle ml-50">Aprovar</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="['pending', 'approved'].includes(data.item.status)"
                  @click="approveCnpj(data.item, 'denied')"
                >
                  <feather-icon icon="XCircleIcon" />
                  <span class="align-middle ml-50">Recusar</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalPhysicians"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </b-card>

        <b-modal
          id="modal-workplace-physician-cnpj-motive-modal"
          ref="workplacePhysicianCnpjMotiveModal"
          :title="workplacePhysicianCnpj ? `${getStatusLabelModal(workplacePhysicianCnpj.company_status)} ${workplacePhysicianCnpj.company_name}` : ''"
          hide-footer
          size="md"
          centered
        >
          <div>
            <div>
              <div v-if="workplacePhysicianCnpj.company_status == 'approved'">
                Deseja realmente autorizar essa empresa?
              </div>
              <b-form-group
                v-if="workplacePhysicianCnpj.company_status != 'approved'"
                class="mt-1"
                label="Motivo"
                label-for="motive"
              >
                <b-form-textarea
                  id="motive"
                  v-model="workplacePhysicianCnpj.motive"
                  name="motive"
                  placeholder="Descreva o motivo..."
                  rows="3"
                />
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button
                variant="primary"
                @click="approveMotiveCnpj(workplacePhysicianCnpj.company_status)"
              >
                {{ getStatusLabelModal(workplacePhysicianCnpj.company_status) }}
              </b-button>
            </div>
          </div>
        </b-modal>
        <b-modal
          id="modal-workplace-physician-cnpj-contract-modal"
          ref="workplacePhysicianCnpjContractModal"
          :title="workplacePhysicianCnpj ? `Anexar Contrato ${workplacePhysicianCnpj.company_name}` : ''"
          hide-footer
          size="md"
          centered
        >
          <div>
            <div>
              <b-table
                class="position-relative"
                small
                :items="() => workplacePhysicianCnpj.contract_files"
                responsive
                :fields="[{key: 'name', label: 'Contrato'}, {key: 'workplace_company_file.due_date', label: 'Vencimento', formatter: formatDateTimeDDMMYYYY}]"
                primary-key="id"
              >
                <template #cell(name)="{ item }">
                  <b-link
                    class="text-underline"
                    @click="openContractFile(item.uploaded_file)"
                  >
                    {{ item.uploaded_file.file_name }}
                  </b-link>
                </template>
              </b-table>
            </div>

            <div>
              <b-form-group
                class="mt-1"
                label="Vencimento"
                label-for="file"
              >
                <b-form-datepicker
                  id="begin-date"
                  v-model="workplacePhysicianCnpj.dueDate"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="pt-BR"
                  label-help=""
                  label-no-date-selected="Selecione uma data"
                />
              </b-form-group>
              <b-form-group
                class="mt-1"
                label="Contrato"
                label-for="file"
              >
                <b-form-file
                  ref="fileInput"
                  v-model="workplacePhysicianCnpj.file"
                  placeholder="Escolha um arquivo ou solte-o aqui..."
                  drop-placeholder="Solte o arquivo aqui..."
                  browse-text="Escolher arquivo"
                  accept=".pdf"
                  @input="checkFileSize"
                />
                <small
                  v-if="fileError"
                  class="text-danger"
                >{{ fileError }}</small>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button
                variant="primary"
                @click="addContract"
              >
                Anexar
              </b-button>
            </div>
          </div>
        </b-modal>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BAlert,
  BLink,
  BRow,
  BCol,
  BFormGroup,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BFormTextarea,
  BModal,
  BTable,
  BButton,
  BCard,
  BPagination, BBadge, BFormDatepicker,
} from 'bootstrap-vue'
import BackBtn from '@core/components/navigation/BackBtn.vue'
import PhysicianListFilters from '@/views/institution/workplace-cnpjs/physician-list/PhysicianListFilters.vue'
import usePhysicianList from '@/views/institution/workplace-cnpjs/physician-list/usePhysicianList'
import {
  formatCnpj, formatCpf, formatDateTimeDDMMYYYY, openLink, truncateString,
} from '@core/utils/utils'
import userStoreModule from '../institutionStoreModule'
import InstitutionViewInstitutionInfoCard from './InstitutionWorkplaceCnpjInfoCard.vue'

export default {
  components: {
    BFormDatepicker,
    BBadge,
    BPagination,
    BCard,
    BButton,
    BTable,
    BModal,
    BFormTextarea,
    BFormFile,
    BDropdownItem,
    BDropdown,
    BFormGroup,
    BAlert,
    BLink,
    BRow,
    BCol,
    BackBtn,
    // Local Components
    InstitutionViewInstitutionInfoCard,
    PhysicianListFilters,
  },
  methods: { truncateString, formatDateTimeDDMMYYYY, formatCnpj },
  setup() {
    const institutionData = ref(null)
    const workplaceData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-institution'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewPhysicianSidebarActive = ref(false)

    const workplacePhysicianCnpjModal = ref(null)
    const workplacePhysicianCnpjMotiveModal = ref(null)
    const workplacePhysicianCnpjContractModal = ref(null)
    const workplacePhysicianCnpj = ref({
      contract_files: [],
      company_name: null,
      company_status: null,
      workplace_name: null,
      workplace_id: null,
      workplace_physician_company_id: null,
      motive: null,
      status: null,
      dueDate: null,
    })
    const institutionId = ref(router.currentRoute.params.id)
    const workplaceId = ref(router.currentRoute.params.workplaceId)
    const fileError = ref(null)
    const fileInput = ref(null)

    store.dispatch('app-institution/fetchInstitution', { id: router.currentRoute.params.id })
      .then(response => { institutionData.value = response.data.data })
      .catch(error => {
        if (error.response.status === 404) {
          institutionData.value = undefined
        }
      })

    store.dispatch('app-institution/fetchInstitutionWorkplace', { id: router.currentRoute.params.id, workplaceId: router.currentRoute.params.workplaceId })
      .then(response => { workplaceData.value = response.data.data })
      .catch(error => {
        if (error.response.status === 404) {
          workplaceData.value = undefined
        }
      })

    const {
      getPhysicianStatus,
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalPhysicians,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPhysicianListTable,
      refetchData,
      statusOptions,
      getStatusLabelModal,
      resolveStatusVariant,
      // UI
      institutionFilter,
      workplaceIdFilter,
      statusFilter,
    } = usePhysicianList()

    institutionFilter.value = institutionId
    workplaceIdFilter.value = router.currentRoute.params.workplaceId

    async function showPhysicianCnpj(workplace) {
      workplacePhysicianCnpj.value.workplace_id = workplace.id
      workplacePhysicianCnpj.value.workplace_name = workplace.name
      workplacePhysicianCnpj.value.motive = null
      workplacePhysicianCnpjModal.value.show()
      refetchData()
    }

    function openAddContract(company) {
      workplacePhysicianCnpj.value.workplace_physician_company_id = company.id
      workplacePhysicianCnpj.value.company_name = company.physician_company.name
      workplacePhysicianCnpj.value.contract_files = company.contract_files
      workplacePhysicianCnpjContractModal.value.show()
    }

    function addContract() {
      const data = {
        id: workplacePhysicianCnpj.value.workplace_physician_company_id,
        file: workplacePhysicianCnpj.value.file,
        dueDate: workplacePhysicianCnpj.value.dueDate,
      }
      store.dispatch('app-institution/addContractPhysicianCompany', data)
        .then(() => {
          refetchData()
          workplacePhysicianCnpjContractModal.value.hide()
        }).catch(() => {
        //
        })
    }

    function approveCnpj(company, status) {
      workplacePhysicianCnpj.value.workplace_physician_company_id = company.id
      workplacePhysicianCnpj.value.company_name = company.physician_company.name
      workplacePhysicianCnpj.value.company_status = status
      workplacePhysicianCnpj.value.motive = null
      workplacePhysicianCnpjMotiveModal.value.show()
    }

    function approveMotiveCnpj() {
      const data = {
        id: workplacePhysicianCnpj.value.workplace_physician_company_id,
        motive: workplacePhysicianCnpj.value.motive,
        status: workplacePhysicianCnpj.value.company_status,
      }
      store.dispatch('app-institution/updatePhysicianCompany', data)
        .then(() => {
          refetchData()
          workplacePhysicianCnpjMotiveModal.value.hide()
        }).catch(() => {
        //
        })
    }

    function openContractFile(contract) {
      store.dispatch('app-institution/getCompanyContractLink', { id: contract.id })
        .then(response => {
          openLink(response.data.data.url)
        }).catch(() => {
        //
        })
    }

    const checkFileSize = f => {
      if (!f) return

      fileError.value = null

      const maxSizeMB = 15
      const maxSizeBytes = maxSizeMB * 1024 * 1024
      if (f.size > maxSizeBytes) {
        fileError.value = `Arquivo muito grande. Tamanho máximo: ${maxSizeMB} MB.`
        workplacePhysicianCnpj.value.file = null
        fileInput.value.reset()
      }
    }

    return {
      isAddNewPhysicianSidebarActive,
      institutionData,
      workplaceId,
      showPhysicianCnpj,
      workplacePhysicianCnpj,
      workplacePhysicianCnpjModal,
      workplacePhysicianCnpjMotiveModal,
      workplacePhysicianCnpjContractModal,
      approveCnpj,
      approveMotiveCnpj,
      openAddContract,
      addContract,
      statusOptions,
      workplaceData,

      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalPhysicians,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPhysicianListTable,
      refetchData,
      statusFilter,
      getStatusLabelModal,
      getPhysicianStatus,
      formatCpf,
      resolveStatusVariant,
      openContractFile,
      checkFileSize,
      fileError,
      fileInput,
    }
  },
}
</script>

<style>

</style>
